import { StoreActionType as Type } from '../../types';
const initialState: any = {
    setLastRegion: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId || 0,
};

export const lastRegionReducer: any = (state: any = initialState, action: any) => {
    switch (action?.type) {
        case Type.SET_LAST_REGION:
            return {
                ...state,
                setLastRegion: action?.payload?.setLastRegion,
            };

        default:
            return state;
    }
};
